import * as Sentry from "@sentry/vue";

export default defineNuxtPlugin((nuxtApp) => {
  if (!process.server) {
    Sentry.init({
      app: nuxtApp.vueApp,
      dsn: "https://890102bbd43c52149b07114fb78016fb@o4507213559758848.ingest.us.sentry.io/4507213561462784",
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
      ],
      // Performance Monitoring
      tracesSampleRate: 1.0, //  Capture 100% of the transactions
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
      // Session Replay
      replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });
  }
});
